// ABOUTME: /software work-orders pending queue list (ShDataGrid2): reference id/report, status, claimedBy, created date.
// ABOUTME: Rows open the related feedback detail panel (which hosts the work-order panel) keyed by feedbackReportId.

import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Text from "../../../../components/theme/text/Text";
import ShLabel from "../../../../components/theme/label/ShLabel";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetPendingWorkOrdersQuery } from "../../../../newapi/feedback/feedbackApiSlice";
import {
    toReferenceId,
    workOrderStatusKey,
    workOrderStatusVariant,
} from "../../feedback/feedbackTriage";

const SpFeedbackDetails = SidepanelLoader(() => import("../../feedback/SpFeedbackDetails"));

const gridOptions = {
    export: false,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const Pending = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState(false);

    const [feedbackId, setFeedbackId] = useState();
    const feedbackIdRef = useRef(feedbackId);

    // Open the related feedback detail (which mounts the work-order panel for Approved reports).
    const openWorkOrder = (params) => {
        if (!params || params.row.skeleton) return;

        const newId = params.row.feedbackReportId;
        if (!newId) return;
        if (feedbackIdRef.current !== newId) {
            if (!spLoading) {
                setSpLoading(true);
            }
            setFeedbackId(newId);
            feedbackIdRef.current = newId;
        }
        setIsExtended(true);
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });
    }, [props]);

    const columns = [
        {
            field: "feedbackReportId",
            headerName: t("feedback_reference"),
            flex: 1,
            sortable: false,
            renderCell: (cellValues) => {
                if (cellValues.row.skeleton) return <ShTextSkeleton />;
                return <Text semibold>{toReferenceId(cellValues.row.feedbackReportId)}</Text>;
            },
        },
        {
            field: "status",
            headerName: t("wo_status"),
            flex: 1,
            renderCell: (cellValues) => {
                if (cellValues.row.skeleton) return <ShTextSkeleton />;
                return (
                    <ShLabel size={32} fitted variant={workOrderStatusVariant(cellValues.row.status)}>
                        {t(workOrderStatusKey(cellValues.row.status))}
                    </ShLabel>
                );
            },
        },
        {
            field: "claimedByUserId",
            headerName: t("wo_claimed_by"),
            flex: 1,
            renderCell: (cellValues) => {
                if (cellValues.row.skeleton) return <ShTextSkeleton />;
                if (!cellValues.row.claimedByUserId) return <Text light>—</Text>;
                return cellValues.row.claimedByUserId;
            },
        },
        {
            field: "createdAt",
            headerName: t("date"),
            flex: 1,
            renderCell: (cellValues) => {
                if (cellValues.row.skeleton) return <ShTextSkeleton />;
                const d = cellValues.row.createdAt ? new Date(cellValues.row.createdAt) : null;
                return d ? d.toLocaleDateString() : "—";
            },
        },
    ];

    return (
        <Box
            sx={{
                height: 1,
                "@media screen and (max-width: 47.9375em)": {
                    paddingTop: 0,
                    paddingX: 0,
                },
            }}
        >
            <ShDataGrid2
                key={theme.palette.mode}
                content={useGetPendingWorkOrdersQuery}
                title={t("pending")}
                gridOptions={gridOptions}
                columns={columns}
                sortModel={{ field: "createdAt", type: "DESC" }}
                onRowClick={openWorkOrder}
            />

            {spLoading && (
                <SpFeedbackDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    feedbackId={feedbackId}
                />
            )}
        </Box>
    );
};

export default Pending;
